<template>

<div class="row pa-5 ">
  <div class="col-md-9">

  <div class="blog-page container ">
    <div v-if="pageHeading">
       <h3 class="section-title text-center mb-4" style="font-weight: 600;
">Latest Blog Posts</h3>
    </div>
    <div v-if="!pageHeading">
     <h4 class="section-title  mb-4" style="font-weight: 600;">Blog:<span style="font-size: 20px;">
      {{ this.BlogTitle }}</span></h4>
    </div>
   

    <div v-if="paginatedPosts.length" class="row">
      <div
        v-for="(post) in paginatedPosts"
        :key="post.id"
        class="col-md-4 mb-4 d-flex align-items-stretch"
      >
        <div class="card shadow-sm blog-card w-100">
          <img
          style="cursor: pointer;"
          @click="this.$router.push(`/blog/post/${post.slug}`)"
            :src="post.image_path"
            class="card-img-top blog-img"
            alt="Blog Image"
          />
          <div class="card-body">
            <h5 style="font-weight: 600;" class="card-title text-truncate " :title="post.title">
              {{ post.title }}
            </h5>
            <p
              class="card-text text-truncate-2-lines mb-5"
              style="font-size: 15px;"
            >
            {{ post.snippet }}
            </p>
            <v-btn
  @click="this.$router.push(`/blog/post/${post.slug}`)"
  class="reed-btn"
>
  Read More
</v-btn>

          </div>
        </div>
      </div>
    </div>

    <div
      class="pagination-container d-flex justify-content-center mt-4"
      v-if="totalPages > 1"
    >
      <button class="page-btn" :disabled="currentPage === 0" @click="changePage(currentPage - 1)">
        ← Prev
      </button>
      <span class="page-number mx-3">Page {{ currentPage + 1 }} of {{ totalPages }}</span>
      <button
        class="page-btn"
        :disabled="currentPage >= totalPages - 1"
        @click="changePage(currentPage + 1)"
      >
        Next →
      </button>
    </div>

    <div v-if="isLoading" class="text-center mt-5">
      <p>Loading...</p>
    </div>
  </div>
  </div>


  <div class="col-md-3 mt-5">

    <div class="bg-white ">

<div  style="padding:20px">
  <div >
    
    <v-text-field
                            v-model="serachData"
                            variant="outlined"
                            label="Search"
                          ></v-text-field>
  </div>
   <div >
    <v-btn style="background: #f07626;color: white;" 
    variant="outlined" @click="getPagination({type:'search',value:serachData})">Search</v-btn>
   </div>
 
</div>

    </div>

<div class="bg-white mt-2">

<div  style="padding:20px">
<h5 class="recent-title mb-3">Subscribe</h5>

  <div >
    
    <v-text-field
                            v-model="Email"
                            variant="outlined"
                            label="Email"
                              :rules="emailRequire"
                          ></v-text-field>
  </div>
   <div >
    <v-btn style="background: #f07626;color: white;" 
    variant="outlined">Subscribe</v-btn>
   </div>
 
</div>

    </div>

    <div class="bg-white mt-2 pa-4">
<h5 class="recent-title mb-3">Categories</h5>

      <div class="row" v-for=" (value,index) of categrioesData" :key="index">

<div class="mt-1" 
style="font-size: 15px;color: #f07626;cursor: pointer;"
@click="getPagination({type:'category',value:value})"
>
  {{ value }}
</div>
<div class="mt-2" v-if="index == categrioesData.length-1?false:true "
style="border-bottom:1px solid lightgray ;">

</div>

      </div>
      

    </div>

  </div> 
</div>

</template>

<script>
import axios from 'axios'
import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  name: 'BlogPage',
  data() {
    return {
      allPosts: [],
      serachData:"",
      Email:"",
      pagedPosts: {},
      currentPage: 0,
      categrioesData:[],
      blogCategories:"",
      perPage: 10,
      isLoading: true,
      getBlock:"",
      domainName:"",
      pagination_api:"",
     pageHeading:true,
     BlogTitle:"",
     emailRequire: [
        (v) => !!v || "This field is required",
        (v) => /.+@.+\..+/.test(v) || "Please enter a valid email address",
      ],
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.allPosts.length / this.perPage)
    },
    paginatedPosts() {
      return this.pagedPosts[this.currentPage] || []
    }
  },
  methods: {


 getConfig() {
      const getConfigData1 = getConfigDataFromLocalStorage();

      if (getConfigData1) {  
        this.getBlock = getConfigData1.payload.portal_configuration.API_endpoints.blog_get
        this.pagination_api=getConfigData1.payload.portal_configuration.API_endpoints.blog_pagination
        this.blogCategories=getConfigData1.payload.portal_configuration.API_endpoints.blog_get_categories
        this.domainName=getConfigData1.payload.portal_configuration.portal_url.replace("https://","")
      }
    },


 async getCategories(){

  try{
    const responce=await axios.get(this.blogCategories)
    console.log(responce,"this.blogCategories")
this.categrioesData=[]
    if(responce?.data?.categories){
      Object.values(responce.data.categories).forEach((obj)=>{
        this.categrioesData.push(obj)
      })
    }
    
  }
  catch (error) {
        console.error('Error fetching posts:', error)
      }


},



async  getPagination($data){
  this.pageHeading=false
this.BlogTitle=$data.value
const req={
  "page": 1,
    "type":$data.type ,
    "value": $data.value,
    "domain":this.domainName
}

try {
        const res = await axios.post(this.pagination_api,req)
        console.log(res,this.pagination_api,'this.pagination_api')
        this.allPosts = res.data.records || []
        this.loadPage(0)     
      } catch (error) {
        console.error('Error fetching posts:', error)
      }

    },


    async fetchPosts() {
      try {
        const res = await axios.get(this.getBlock)
        console.log(res,this.getBlock,'this.getBlock')
        this.allPosts = res.data.news_letter || []
        this.loadPage(0)
      } catch (error) {
        console.error('Error fetching posts:', error)
      } finally {
        this.isLoading = false
      }
    },
    loadPage(page) {
      const start = page * this.perPage
      const end = start + this.perPage
      this.pagedPosts[page] = this.allPosts.slice(start, end)
    },
    changePage(page) {
      if (!this.pagedPosts[page]) {
        this.loadPage(page)
      }
      this.currentPage = page
    },
    truncateContent(content) {
      const div = document.createElement('div')
      div.innerHTML = content
      const text = div.textContent || div.innerText || ''
      return text.length > 100 ? text.slice(0, 100) + '...' : text
    }
  },
  mounted() {
    this.getConfig()
    this.getCategories()
const id = this.$route.params.id
if(id){
  this.isLoading=false
this.getPagination({type:'category',value:id})
}
else{
 this.fetchPosts()
}

   
  }
}
</script>

<style scoped>
.card-img-top{
  width: 100%;
  height:150px;
}
.reed-btn{
  background: #f07626;
  color: white;
  border: none;
  text-transform: capitalize;
  font-size: 12px;
  height: 28px;
  position: absolute;
   bottom: 15px;padding: 5px;
}
.text-truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;             
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3.2em;             
  line-height: 1.6em;                
}
.recent-title {
  color: #000;
  font-weight: 600;
}
.recent-list li {
  font-size: 14px;
  line-height: 1.6;
}
.recent-list a:visited{
    color:black !important;
}
</style>